(function () {
  $.extend(tower, {
    initCheckItemsIn: function (wrapper) {
      var $wrapper = $(wrapper)

      $wrapper
        // toggle complete check item
        .on('checked unchecked', '.check-item .simple-checkbox', function (event) {
          var $checkbox = $(event.currentTarget)
          var $checkItem = $checkbox.closest('.check-item')
          var completed = $checkbox.is('.checked')

          $
            .ajax({
              url: '/check_items/' + $checkItem.data('guid') + '/completion',
              method: completed ? 'POST' : 'DELETE'
            })
            .done(function (data, status, xhr) {
              var $updatedCheckItem = $(data.html)
              var $checkItemsRoot = $checkItem.closest('[data-check-items-root]')
              var updatedCheckItemGuid = $updatedCheckItem.attr('data-guid')

              $checkItem.replaceWith($updatedCheckItem)
              tower.initCheckItem($updatedCheckItem, { willRemoveLink: $('#page-todo').length ? true : false })
              tower.initPermission($updatedCheckItem)
              $checkItemsRoot.trigger('toggleCheckItem', [updatedCheckItemGuid, completed ? 'check' : 'uncheck'])
              tower.todoSubject.next('update', {
                id: data.todo_id,
                html: data.todo_html,
              });
            })
        })
        // toggle complete check item in form
        .on('checked unchecked', '.check-item-form .simple-checkbox', function (event) {
          var $checkbox = $(event.currentTarget)
          var $checkItemForm = $checkbox.closest('.check-item-form')
          var $checkItem = $wrapper.find('.check-item[data-guid="' + $checkItemForm.data('check-item-guid') + '"]')
          var completed = $checkbox.is('.checked')

          $
            .ajax({
              url: '/check_items/' + $checkItemForm.data('check-item-guid') + '/completion',
              method: completed ? 'POST' : 'DELETE'
            })
            .done(function (data, status, xhr) {
              var $updatedCheckItem = $(data.html).hide()
              var updatedCheckItemGuid = $updatedCheckItem.attr('data-guid')

              $checkItemForm.toggleClass('completed')
              $checkItem.replaceWith($updatedCheckItem)
              tower.initCheckItem($updatedCheckItem, { willRemoveLink: $('#page-todo').length ? true : false })
              tower.initPermission($updatedCheckItem)
              $checkItemsRoot.trigger('toggleCheckItemForm', [updatedCheckItemGuid, completed ? 'check' : 'uncheck'])
            })
        })
        // shortcuts
        .on('keydown', '.check-item-name', function (event) {
          if (event.which == KEY_TAB) {
            event.preventDefault()

            $(event.currentTarget).nextAll('.check-item-quicklink').first().focus()
          }
        })
        .on('keydown', '.check-item-quicklink', function (event) {
          if (event.which == KEY_ENTER) {
            event.preventDefault()

            var $quickLink = $(event.currentTarget)

            $quickLink
              .trigger('mouseenter')
              .trigger('click')

            var popover = $quickLink.data('popover')
            if (popover) {
              var $popover = $quickLink.data('popover').el

              $popover
                .find('.txt-due-date')
                .on('keydown', function (event) {
                  if (event.which == KEY_TAB) {
                    event.preventDefault()
                    $quickLink.closest('.check-item').trigger('focusNextCheckItem')
                  }
                })

              $popover
                .find('.member-select .select-result')
                .focus()
            }
          }
        })
        .on('keydown', '.check-item-form-name', function (event) {
          if (event.which == KEY_TAB) {
            event.preventDefault()

            var $nameField = $(event.currentTarget)
            var $quickLink = $nameField.nextAll('.check-item-form-quicklink').first()

            $nameField.trigger('blur')
            $quickLink
              .trigger('mouseenter')
              .trigger('click')
              .data('popover')
              .el
              .find('.member-select .select-result')
              .focus()
          }
        })
        .on('focusNextCheckItem', function (event) {
          var $checkItem = $(event.target)
          var $nextCheckItem = $checkItem.next('.check-item')
          var $linkAddCheckItem = $checkItem.next('.link-add-check-item')

          if ($nextCheckItem.length) {
            $nextCheckItem.find('.check-item-name').focus()
          } else if ($linkAddCheckItem.length) {
            $linkAddCheckItem.focus()
          }
        })
        // update check item
        .on('ajax:success', '.check-item-form[data-check-item-guid]', function (event, data) {
          if (!$(event.target).is('.check-item-form')) return

          var $checkItemForm = $(event.currentTarget)
          var $checkItem = $wrapper.find('.check-item[data-guid="' + $checkItemForm.data('check-item-guid') + '"]')
          var $updateCheckItemRes = $(data.html)

          $checkItemForm.remove()
          $checkItem.replaceWith($updateCheckItemRes)
          $updateCheckItemRes.each(function(index, checkItem) {
            if (checkItem.nodeName === "#text") {
              return
            }
            tower.initCheckItem($(checkItem), { willRemoveLink: $('#page-todo').length ? true : false })
          })
        })
        // close check item form
        .on('click', '.check-item-form .btn-cancel', function (event) {
          var $form = $(event.currentTarget).closest('.check-item-form')
          var $checkItem = $wrapper.find('.check-item[data-guid="' + $form.data('check-item-guid') + '"]')

          $form.remove()
          if ($checkItem.length) $checkItem.show()
        })
        // destroy check item
        .on('ajax:success', '.check-item .check-item-action.delete', function (event, data) {
          var $checkItem = $(event.currentTarget).closest('.check-item');
          var $checkItemsRoot = $checkItem.closest('[data-check-items-root]');
          var checkItemGuid = $checkItem.data('guid');
          var $checkItemForm = $checkItemsRoot.find('.check-item-form');
          $checkItem.remove()
          $checkItemsRoot.trigger('destroyCheckItem', [checkItemGuid])

          if ($('.check-item').length < 1) {
            $(".topic").removeClass('has-check-item');
            if ($checkItemForm.length) {
              $checkItemForm.remove();
            }
          }

          tower.todoSubject.next('update', {
            id: data.todo_id,
            html: data.todo_html,
          });
        })

      $wrapper.find('.check-item').each(function (index, checkItem) {
        tower.initCheckItem(checkItem, { willRemoveLink: $('#page-todo').length ? true : false })
      })
    },

    initCheckItems: function (checkItems, context = null) {
      $context = context ? $(context) : $('#page-todo');
      var $checkItems = $(checkItems);
      var updateProgress = function () {
        var $title = $context.find('.todolist .todo-content');
        var $progress = $context.find('.progress-wrap');
        var $allCheckItems = $checkItems.find('.check-item');
        var $completedCheckItems = $allCheckItems.filter('.completed');
        var value = 0;

        if ($allCheckItems.length > 0) {
          if (!$progress.length) {
            $title.find('.progress-wrap').remove();
            $title.find('.content-linkable').after($('#tpl-todo-progress').html());
            $progress = $('#page-todo .progress-wrap');
          }

          var allCount = $allCheckItems.length;
          var completedCount = $completedCheckItems.length;
          value = parseInt(parseFloat(completedCount / allCount).toFixed(2) * 100);

          $progress
            .find('.progress-pie')
            .attr('title', value + '%')
            .attr('data-pie', value);

          $progress
            .find('.todo-progress')
            .attr('title', '总共有 ' + allCount + ' 个检查项，已完成 ' + completedCount + ' 个')
            .text(completedCount + '/' + allCount);
        } else {
          $progress.remove();
        }
      }

      tower.initCheckItemsIn($checkItems)
      $checkItems.find('.check-item-name')
        .removeAttr('href')
        .removeAttr('data-stack');

      $checkItems
        // validate check item
        // .on('validate', '.check-item-form .check-item-form-name', function (event, val, args) {
        //   var result = { valid: true }
        //   var maxlength = 190

        //   if (!val) {
        //     result.valid = false
        //     result.errorMsg = ''
        //   } else if (val.length > maxlength) {
        //     result.valid = false
        //     result.errorMsg = ''
        //     simple.dialog.message({
        //       content: '任务内容最长 ' + maxlength + ' 个字符'
        //     })
        //   }

        //   return result
        // })
        // create check item
        .on('ajax:success', '.check-item-form:not([data-check-item-guid])', function (event, data) {
          var $checkItemRes = $(data.html)
          var $form = $(data.form_html)

          $checkItems
            .find('.check-item-form:not([data-check-item-guid])')
            .replaceWith($checkItemRes)
          .end()
            .find('.link-add-check-item')
              .before($form)

          $checkItemRes.each(function(index, checkItem) {
            if (checkItem.nodeName === "#text") {
              return
            }
            tower.initCheckItem($(checkItem), {willRemoveLink: true})
          })
          tower.initCheckItemForm($form)
          updateProgress()
          tower.todoSubject.next('update', {
            id: data.todo_id,
            html: data.todo_html,
          });
        })
        // close check item form
        .on('click', '.check-item-form .btn-cancel', function (event) {
          if ($checkItems.find('.check-item').length < 1) {
            $(".topic").removeClass('has-check-item');
          }

          if ($checkItems.find('.check-item-form').length == 0) {
            $checkItems.removeClass('adding');
          }
        })
        .on('toggleCheckItem', function (event) {
          updateProgress()
        })
        .on('toggleCheckItemForm', function (event) {
          updateProgress()
        })
        .on('destroyCheckItem', function (event) {
          updateProgress()
        })

      if($checkItems.data('sortable') === true) {
        $checkItems.sortable({
          scrollSensitivity: 100,
          cursor: 'move',
          distance: 20,
          items: '.check-item',
          handle: '.check-item-name',
          start: function(e, ui) {
            ui.item.addClass('moving')
          },
          stop: function(e, ui) {
            checkItem = ui.item;
            $.ajax({
                url: checkItem.data('sort-url'),
                data: {
                    prev_check_item_guid: checkItem.prev('.check-item').data('guid'),
                    next_check_item_guid: checkItem.next('.check-item').data('guid')
                }
            });

            checkItem.removeClass('moving')
          }
        })
      }

      updateProgress();
    },

    initExpandedTodo: function (expandedTodo, memberGuid) {
      var $expandedTodo = $(expandedTodo)
      var $todo = $expandedTodo.find('.todo')
      var $checkItems = $expandedTodo.find('.todo-check-items')
      var isPushUpdate = typeof memberGuid != 'undefined'
      var updateProgress = function (num) {
        var all = parseInt($todo.data('check-items-size'))
        var completed = parseInt($todo.data('completed-check-items-size'))
        var newCompleted = completed + num
        var $progressText = $todo.find('.todo-progress')

        if (isNaN(all) || isNaN(completed)) return

        $todo.data('completed-check-items-size', newCompleted)
        $progressText.text('(' + newCompleted + '/' + all + ')')
      }
      var handleCheckItemComplete = function () {
        $checkItems
          .find('.check-item, .check-item-form')
          .filter('.completed')
          .each(function (i, checkItem) {
            var $checkItem = $(checkItem)

            $checkItem.fadeTo(200, 0);
            $checkItem.slideUp(200, function() {
              $checkItem.remove();
              handleCheckItemRemove();
            })
          })
      }
      var handleCheckItemRemove = function () {
        if (!$expandedTodo.is('.participant')) return

        if ($checkItems.find('.check-item').length == 0 && $checkItems.find('.check-item-form').length == 0) {
          $expandedTodo.fadeTo(200, 0);
          $expandedTodo.slideUp(200, function() {
            var $currentPage = $('.page-inner:last');
            $expandedTodo.remove();
            $currentPage.trigger('boxChanged');
          })
        }
      }

      $expandedTodo
        .on('toggleCheckItem', function (event, checkItemGuid, action) {
          var num = action == 'check' ? 1 : -1

          updateProgress(num)
          handleCheckItemComplete()
        })
        .on('toggleCheckItemForm', function (event, checkItemGuid, action) {
          var num = action == 'check' ? 1 : -1

          updateProgress(num)
          handleCheckItemComplete()
        })
        .on('destroyCheckItem', function (event) {
          updateProgress(0)
          handleCheckItemRemove()
        })

      if (isPushUpdate) {
        $checkItems
          .find('.check-item')
          .filter(function (index, checkItem) {
            return checkItem.getAttribute('data-assignee-guid') !== memberGuid
          })
          .remove()

        tower.adjustTodo($todo)
        tower.adjustReadableDate($todo)
        tower.adjustReadableTime($todo)
        tower.initPermission($todo)
        tower.initCheckItemsIn($expandedTodo)

        if ($todo.data('assignee-guid') !== memberGuid) {
          $expandedTodo.addClass('participant')
        }

        $expandedTodo.removeClass('uninitialized')
      } else {
        tower.adjustTodo($todo)
        tower.adjustReadableDate($todo)
        tower.adjustReadableTime($todo)
        tower.initPermission($todo)
        tower.initCheckItemsIn($expandedTodo)
      }
    },

    initCheckItem: function (checkItem, options) {
      var $checkItem = $(checkItem)
      var willRemoveLink = options && options.willRemoveLink

      tower.adjustReadableTime($checkItem)
      tower.adjustReadableDate($checkItem)
      if ($checkItem.find(':checkbox').length) {
        simple.checkbox({
          el: $checkItem.find(':checkbox')
        })
      }

      if (willRemoveLink) {
        $checkItem.find('.check-item-name')
          .removeAttr('href')
          .removeAttr('data-stack')
      }
    },

    initCheckItemForm: function (form) {
      var $form = $(form)
      var $textarea = $form.find('[name="todos_check_item[name]"]')

      $textarea.focus().autosize()
      $textarea.on('keydown', function(e) {
        if (e.which === KEY_ENTER && !tower.metaKey(e)) {
          e.preventDefault()
          $form.trigger('submit')
        }
      })

      if ($form.find(':checkbox').length) {
        simple.checkbox({
          el: $form.find(':checkbox')
        })
      }
    },

    newCheckItem: function (options, wrapper=null) {
      var $wrapper = wrapper ? $(wrapper) : $('.page-inner:last')
      var $checkItems = $wrapper.find('.check-items');
      var $form = $(options.form)

      $checkItems
        .addClass('adding')
        .find('.link-add-check-item')
        .before($form)
      tower.initCheckItemForm($form)
    },

    editCheckItem: function (options) {
      var $currentPage = $('.page-inner:last'),
          $checkItem = $currentPage.find(".check-item[data-guid=" + options.guid + "]"),
          $form = $(options.form)

      if ($currentPage.find(".check-item-form[data-check-item-guid=" + options.guid + "]").length) return

      $checkItem.hide().after($form)
      tower.initCheckItemForm($form)
    }
  })
}())
